import classNames from 'classnames/bind';

import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const RoundRadioButton = ({
  value, name, selectedFilterValue, setValue, filterItemInfo, buttonDisabled,
  customClass = '', hasBigScreenDesign,
}) => (
  <div
    className={cx('radio-btn', { disabled: buttonDisabled, big_screen: hasBigScreenDesign }, `${customClass}`)}
    onClick={() => setValue(filterItemInfo)}
  >
    <input
      type="radio"
      value={value}
      id={value}
      name="selector"
      checked={selectedFilterValue === value}
      onChange={() => {}}
    />
    <div className={Styles.check} />
    <label htmlFor={value}>{name}</label>
  </div>
);

export default withComponentName(RoundRadioButton);
